import React, { useState } from 'react'
import StatusComp from '../../../components/StatusComp';
import CommonDatePicker from '../../../components/CommonDatePicker';
import SelectBox from '../../../components/SelectBox';
import { siteDetails } from '../../redux/api/dummyJson';
import { useLocation } from 'react-router-dom';


const CompanySiteReport = () => {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);

    const [company, setCompany] = useState([])
    const [selectedCompany, setSelectedCompany] = useState([])

    const [data, setData] = useState([])
    const [selectedOption, setSelectedOption] = useState(null);

    const location = useLocation()
    const type = location?.state?.type

    const handlePreview = () => {
        console.log("From:", fromDate)
        console.log("To:", toDate)
        console.log("Company:", selectedCompany)
        console.log("Site:", selectedOption)
    }

    return (
        <div className="dashRightView">
            <StatusComp
                name={'Site'}
                type={'Report'}
                hide={true}
            />
            <div className={`d-flex ${type ? "gap-5" : "gap-5"}`}>

                <CommonDatePicker
                    fromDate={fromDate}
                    toDate={toDate}
                    setFromDate={setFromDate}
                    setToDate={setToDate}
                />





                <div className="col-md-2">
                    <label className="form-label">Select Site</label>
                    <SelectBox
                        arrayData={siteDetails}
                        data={data}
                        setData={setData}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}

                        style={true}
                    />
                </div>

                {/* Preview Button */}
                <div className="col-md-1 mt-4">
                    <button
                        onClick={handlePreview}
                        className="submit-btn"
                        disabled={!fromDate || !toDate || !selectedCompany?.label || !selectedOption?.label}
                    >
                        Preview
                    </button>
                </div>
            </div>
        </div>
    )
}

export default CompanySiteReport
